export default "__VITE_ASSET___bXRSOjB__"